<template>
  <div>
    <h3>Hello {{username}},</h3>
    <h3>Let everyone know you're online and working.</h3>
    <div class="m-t-md m-b-md">
      <div>
        <form @submit.prevent="signInToSlack">
          <label class="label">Reason (Optional)</label>
          <p class="control" v-if="typedreason">
            <input class="input form-control m-b-sm" type="text" placeholder="Add a reason" v-model="formReason">
            <a class="centered text-sm text-u-l" @click.prevent="existingReason">Use an existing reason?</a>
          </p>
          <p class="control" v-if="existing">
            <v-select class="m-b-sm" :value.sync="formReason" :options="existingReasons" v-model="formReason"></v-select>
            <a class="centered text-sm text-u-l" @click.prevent="typedReason">Type in a new reason?</a>
          </p>
          <div class="control">
            <button class="button is-primary is-large centered kuzco-green" v-bind:class="{ 'is-disabled' : disabled }">Sign In
              <span v-bind:class="{ 'slack-loader' : loading }"></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { store } from '../store/store';
  import axios from 'axios'
  import moment from 'moment'
  import vSelect from 'vue-select'

  export default {
    name: 'Signin',
    components: {vSelect},
    data () {
      return {
        formReason: null,
        existing: false,
        typedreason: true,
        loading: false,
        existingReasons: null,
        disabled: false
      }
    },
    notifications: {
      signInError: {
        title: 'Signed in already',
        message: 'You are already signed in.',
        type: 'error' //Default: 'info', also you can use VueNotifications.type.error instead of 'error'
      }
    },
    watch: {
      '$route': 'fetchData'
    },
    created: function() {
      this.fetchData()
    },
    computed: {
      username () {
        return store.state.username;
      },
      logreason () {
          return store.state.logreason
      },
      logdate () {
        return store.state.logdate;
      },
      lastactivity () {
        return store.state.lastactivity;
      }
    },
    methods: {
      fetchData: function () {
        var self = this
        if ( localStorage.kloggedin == 'true') {
          self.$router.push('/signedin')
        }
        else {
            // do nothing
        }
        axios.get('https://api.kuzcoapp.com/api/v1/me/reasons')
          .then( function (response) {
            let reasonsArr = []
            let _reasons = response.data.data
            for (let i in _reasons) {
              reasonsArr.push(_reasons[i])
            }
            self.existingReasons = reasonsArr
          })
      },
      existingReason: function () {
        var self = this
        self.existing = true
        self.typedreason = false
      },
      typedReason: function () {
        var self = this
        self.existing = false
        self.typedreason = true
      },
      signInToSlack: function () {
        var self = this
        self.loading = true
        self.disabled = true
        axios.post('https://api.kuzcoapp.com/api/v1/log', {
          log_type: 1,
          log_description: self.formReason
        })
          .then (function(response) {
            self.formReason = null
            self.loading = false
            self.disabled = false

            var _time = response.data.data.updated_at;

            var _momenttime = moment(_time).format('MMMM Do YYYY, h:mm:ss a')
            var _reason = response.data.data.log_description
            var _signedin = true
            var emptyreason = '';
            if (_reason) {
              store.commit ('_logreason', _reason)
              localStorage.logreason = _reason
            }
            else {
              store.commit ('_logreason', emptyreason)
              localStorage.logreason = emptyreason
            }
            store.commit ('_logdate', _momenttime)
            store.commit ('_signedin', _signedin)
            localStorage.logdate = _momenttime
            localStorage.kloggedin = true

            self.$router.push('/signedin')
          })
          .catch(function (error) {
            if ( error.response.data.code == '411' ) {
              self.signInError({ message: error.response.data.message})
              let _lastactivity = store.state.lastactivity

              for (let i in _lastactivity) {
                if (i > 1) break;
                localStorage.logreason = _lastactivity[i].reason
                localStorage.logdate = _lastactivity[i].date
                localStorage.kloggedin = true
              }
//              self.$router.push('/signedin')
            }
            self.loading = false
            self.disabled = false
          });
      }
    },
  }
</script>

<style scoped lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .kuzco-green {
    background-color: $kuzcogreen !important;
  }
  .panel--top {
    h3 {
      font-size: 18px;
    }
  }
  a {
    color: #3E454F;
  }
  .centered {
    margin: 0 auto;
    display: table;
  }
  form {
    max-width: 100%;
    width: 600px;
    margin: auto;
    text-align: center;
    label {
      font-size: 16px;
    }
    .form-control {
      height: 40px;
      font-size: 14px;
    }
  }
  .slack-loader {
    margin: -4px auto;
    display: inline-block;
    font-size: 4px;
    text-indent: -9999em;
    width: 4em;
    height: 4em;
    border-radius: 50%;
    background: #ffffff;
    background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .slack-loader:before {
    width: 50%;
    height: 50%;
    background: #ffffff;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  .slack-loader:after {
    background: $kuzcogreen;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// Signin.vue?7d701054